import React, { useEffect, useState } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import { findAllKjsMunicipalityFilterPageable } from '../../../actions/kjsMunicipality';
import Form from '../../Reusable/Form/Form';
import { config } from './KjsConfig';
import withTranslations from '../../../utils/HighOrderComponent';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import dot from 'dot-object';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import { findAllKjs } from '../../../actions/kjs';
import { findAllMunicipality } from '../../../actions/municipality';

const KjsFilter = ({
  t,
  findAllKjsMunicipalityFilterPageable,
  saveFilters,
  initialValues,
  initialStateValues,
  savePostData,
  setResetData,
  kjsList,
  municipalityList,
  findAllMunicipality,
  findAllKjs,
  pageSize,
}) => {
  useEffect(() => {
    findAllKjs();
    findAllMunicipality();
  }, [findAllKjs]);
  const { AccordionForm } = t || {};

  const [activeKey, setActiveKey] = useState('-1');

  const mappedMunicipalityList = municipalityList.map((municipality) => {
    return {
      id: municipality.id,
      name: municipality.name,
    };
  });

  const { fields } = config(kjsList, mappedMunicipalityList);
  const decoratedOnClick = useAccordionToggle('0', () => {
    setActiveKey('-1');
  });

  const handleSubmit = (values) => {
    const dotNotationObj = dot.dot(values);

    const postData = {
      tableName: 'kjs_municipality',
      filterCriteria: Object.entries(dotNotationObj)
        .map((entry) => {
          switch (entry[0]) {
            case 'kjsEntity.id':
              return (
                entry[1] && {
                  columnName: 'kjs.id',
                  columnValue: entry[1],
                }
              );
            case 'kjs.uniqueNumber':
            case 'kjs.pib':
            case 'kjs.id.id':
            case 'municipality.id':
              return (
                entry[1] && {
                  columnName: entry[0],
                  columnValue: entry[1],
                }
              );
            default:
              return null;
          }
        })
        .filter((item) => !!item),
    };
    if (postData.filterCriteria?.length === 0) {
      resetFilters();
    } else {
      savePostData(postData);
      findAllKjsMunicipalityFilterPageable(postData, pageSize, () =>
        saveFilters(values)
      );
    }
  };

  const packConfig = () => {
    return {
      fields: [...fields],
    };
  };

  const packTranslations = () => {
    return {
      ...t,
    };
  };

  const resetFilters = () => {
    savePostData(null);
    setResetData(true);
    return saveFilters(initialStateValues);
  };
  const filterCardStyle =
    activeKey === '0' ? 'form-row card-header-open' : 'form-row';
  return (
    <div className="Filters m-auto">
      <Accordion activeKey={activeKey}>
        <Card>
          <Accordion.Toggle
            as={Card.Header}
            variant="link"
            eventKey="0"
            className={filterCardStyle}
            onClick={() => {
              if (activeKey !== '0') {
                setActiveKey('0');
              } else {
                setActiveKey('-1');
              }
            }}
          >
            <div className="float-left col-md-11">{AccordionForm.title}</div>
            {activeKey === '0' && initialValues !== initialStateValues && (
              <div className="col-md-1 float-right">
                <Button
                  variant="warning"
                  onClick={() => {
                    resetFilters();
                  }}
                >
                  {AccordionForm.reset}
                </Button>
              </div>
            )}
          </Accordion.Toggle>

          <Accordion.Collapse eventKey="0">
            <Card.Body style={{ paddingTop: '-2vh' }}>
              <Form
                className={'KjsForm'}
                onSubmit={handleSubmit}
                initialValues={initialValues}
                formConfig={packConfig()}
                translations={packTranslations()}
                removeCancel={true}
                submitLabel={AccordionForm.filter}
                decoratedOnClick={decoratedOnClick}
              />
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loggedUser: state.loggedUser?.loggedUser,
  kjsList: state.kjs.kjsList || [],
  municipalityList: state.municipality.municipalityList || [],
});

const mapDispatchToProps = (dispatch) => {
  return {
    findAllKjsMunicipalityFilterPageable: (
      postData,
      pageSize,
      successCallback
    ) => {
      dispatch(
        findAllKjsMunicipalityFilterPageable(
          0,
          pageSize,
          postData,
          successCallback
        )
      );
    },
    findAllKjs: () => {
      dispatch(findAllKjs());
    },
    findAllMunicipality: () => {
      dispatch(findAllMunicipality());
    },
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withTranslations(KjsFilter, 'KjsFilter'))
);
